import { actionTypes } from "../actions/plans";

const variable = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_PLANS:
      return action.payload;
    default:
      return state;
  }
};

export default variable;